import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// variables/effect.ts
init_react_import();
import { Color } from "@persona-id/design-tokens";
var Elevation;
(function(Elevation2) {
  Elevation2["High"] = "0px 11px 15px rgba(191, 191, 199, 0.2), 0px 9px 46px rgba(191, 191, 199, 0.12), 0px 24px 38px rgba(191, 191, 199, 0.14)";
  Elevation2["Mid"] = "0px 10px 14px rgba(0, 0, 0, 0.08), 0px 6px 6px rgba(0, 0, 0, 0.06)";
  Elevation2["Low"] = "0px 4px 5px rgba(191, 191, 199, 0.2), 0px 3px 14px rgba(191, 191, 199, 0.12), 0px 8px 10px rgba(191, 191, 199, 0.14)";
})(Elevation || (Elevation = {}));
var Hairline = {
  Bottom: `0px 1px 0px ${Color.BorderHairline}`,
  Top: `0px -1px 0px ${Color.BorderHairline}`,
  Right: `1px 0px 0px ${Color.BorderHairline}`
};

export {
  Elevation,
  Hairline
};
//# sourceMappingURL=chunk-PK4FSMOO.mjs.map